// PRIMARY
export const PRI_900 = '#061437';
export const PRI_800 = '#0B1D43';
export const PRI_700 = '#112A53';
export const PRI_600 = '#193863';
export const PRI_500 = '#234974';
export const PRI_400 = '#5180AB';
export const PRI_300 = '#7BAED5';
export const PRI_200 = '#ADD6F1';
export const PRI_100 = '#D5ECF8';

export const DANGER_900 = "#770E30";
export const DANGER_800 = "#901734";
export const DANGER_700 = "#B3253B";
export const DANGER_600 = "#D63641";
export const DANGER_500 = "#F94E4B";
export const DANGER_400 = "#FB8577";
export const DANGER_300 = "#FDA793";
export const DANGER_200 = "#FECAB7";
export const DANGER_100 = "#FEE7DB";

export const WARNING_900 = "#783F04";
export const WARNING_800 = "#925207";
export const WARNING_700 = "#B56D0C";
export const WARNING_600 = "#D88B12";
export const WARNING_500 = "#FCAC19";
export const WARNING_400 = "#FDC752";
export const WARNING_300 = "#FED774";
export const WARNING_200 = "#FEE8A2";
export const WARNING_100 = "#FEF5D0";

export const SUCCESS_900 = "#345111";
export const SUCCESS_800 = "#45621C";
export const SUCCESS_700 = "#5C792C";
export const SUCCESS_600 = "#759141";
export const SUCCESS_500 = "#90A959";
export const SUCCESS_400 = "#B7CB83";
export const SUCCESS_300 = "#D5E5A4";
export const SUCCESS_200 = "#ECF6C7";
export const SUCCESS_100 = "#F6FAE2";

export const INFO_900 = "#132D51";
export const INFO_800 = "#1F4062";
export const INFO_700 = "#325A7A";
export const INFO_600 = "#497692";
export const INFO_500 = "#6494AA";
export const INFO_400 = "#8DBCCC";
export const INFO_300 = "#ACDBE5";
export const INFO_200 = "#CDF1F6";
export const INFO_100 = "#E6F9FA";


// export const PRI_900 = "#0E3E79";
// export const PRI_800 = "#185892";
// export const PRI_700 = "#267BB6";
// export const PRI_600 = "#37A2D9";
// export const PRI_500 = "#4CCDFD";
// export const PRI_400 = "#78E2FD";
// export const PRI_300 = "#93F0FE";
// export const PRI_200 = "#B7FAFE";
// export const PRI_100 = "#DBFEFE";

// export const PRI_900 = "#7A1422";
// export const PRI_800 = "#932229";
// export const PRI_700 = "#B73835";
// export const PRI_600 = "#DB5B4E";
// export const PRI_500 = "#FF846B";
// export const PRI_400 = "#FFAB90";
// export const PRI_300 = "#FFC2A6";
// export const PRI_200 = "#FFDBC3";
// export const PRI_100 = "#FFEFE1";


// SECONDARY 1
export const SEC1_900 = "#131625";
export const SEC1_800 = "#1E222E";
export const SEC1_700 = "#2C2F38";
export const SEC1_600 = "#3D3E42";
export const SEC1_500 = "#87888D";
export const SEC1_400 = "#BFC0C5";
export const SEC1_300 = "#BFC0C5";
export const SEC1_200 = "#E7E8EC";
export const SEC1_100 = "#F2F3F5";

// SECONDARY 2
export const SEC2_900 = "#854462";
export const SEC2_800 = "#A76C82";
export const SEC2_700 = "#C79DA9";
export const SEC2_600 = "#E8D8DB";
export const SEC2_500 = "#F0E4E4";
export const SEC2_400 = "#F0E4E4";
export const SEC2_300 = "#F7EDEC";
export const SEC2_200 = "#FCF7F4";
export const SEC2_100 = "#FCFBF9";

// NEUTRAL
export const NTRL_700 = "#111111";
export const NTRL_600 = "#333333";
export const NTRL_500 = "#4A4A4A";
export const NTRL_400 = "#828282";
export const NTRL_300 = "#BDBDBD";
export const NTRL_200 = "#E0E0E0";
export const NTRL_100 = "#FAFAFB";
export const NTRL_000 = "#FAFAFB";
